/**
 * dev-ops-aware-devices-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T23:28:47Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DeviceGroupOverview } from './deviceGroupOverview';


/**
 * A collection of device group overviews
 */
export interface DeviceGroupOverviewCollection { 
    /**
     * An array of the results of the device group search
     */
    results: Array<DeviceGroupOverview>;
    /**
     * A count of how many possible results there are, unbounded by page size.
     */
    totalResultCount: number;
}
